import { TransactionsTable } from 'src/components/Address/EvmChains/TransactionsTable';
import { AddressSummary } from 'src/components/Address/AddressSummary/AddressSummary';
import { TokenHoldingsOverview } from './TokenHoldings/TokenHoldingsOverview';
import {
  Tabs,
  TabsList,
  TabsTrigger,
  TabsContent,
} from 'src/components/ui/tabs';
import { TokenHoldingsTable } from './TokenHoldings/TokenHoldingsTable';
import { useSearchParams } from 'react-router-dom';

export const EVMAddressPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'transactions';

  const handleTabChange = (value: string) => {
    const newSearchParams = new URLSearchParams(searchParams);
    if (value === 'transactions') {
      // Remove tab param for default tab to keep URLs clean
      newSearchParams.delete('tab');
    } else {
      newSearchParams.set('tab', value);
    }
    setSearchParams(newSearchParams);
  };

  return (
    <div className="space-y-6 rounded-lg bg-white p-6 shadow-lg">
      <AddressSummary />
      <TokenHoldingsOverview />

      <div className="mx-auto max-w-[1500px]">
        <Tabs
          value={activeTab}
          onValueChange={handleTabChange}
          className="w-full"
        >
          <TabsList className="mb-3">
            <TabsTrigger value="transactions">Transactions</TabsTrigger>
            <TabsTrigger value="token-balances">Token Balances</TabsTrigger>
          </TabsList>

          <TabsContent value="transactions">
            <TransactionsTable />
          </TabsContent>
          <TabsContent value="token-balances">
            <TokenHoldingsTable />
          </TabsContent>
        </Tabs>
      </div>
    </div>
  );
};
